module.exports = __webpack_public_path__ + "img/good4.b4d86a0a.jpg";